import Api from '../api.js'

const state = {
  products: []
}

const mutations = {
  loadProducts (state, products) {
    state.products = products
  }
}

const actions = {
  load ({commit, state}) {
    return new Promise((resolve, reject) => {
      Api.getV2('payment/products').then(response => {
        commit('loadProducts', response.body)
        resolve()
      }).catch(reject)
    })
  }
}

const getters = {
  byMetaId: state => id => state.products.filter(product => product.metadata && product.metadata.id === id)[0] || {},
  byId: state => id => state.products.filter(product => product.id === id)[0] || {},
  premium: (state, getters, rootState, rootGetters) => (state.products.filter(product => product.metadata && product.metadata.id === 'premium')[0] || false) && rootState.config.subscriptions,
  storagePlus: (state, getters, rootState, rootGetters) => (state.products.filter(product => product.metadata && product.metadata.id === 'storage+')[0] || false) && rootState.config.subscriptions
}

export default {
  namespaced: true,
  state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/payment/products.js